export function dispatchMyVoicesUpdateEvent(items) {
    const event = new CustomEvent('myVoicesUpdate', {
        detail: items
    });
    window.dispatchEvent(event);
}